import { PageDetails } from '../../../types/Performance/MyReview/myReviewTypes'

export const initialObservationRatingDetails: PageDetails = {
  country: null,
  departmentId: null,
  departmentName: null,
  description: '',
  displayOrder: 0,
  empCountry: '',
  handCountry: [],
  id: 0,
  pageName: '',
  sectionId: null,
  sectionName: null,
  title: '',
  type: '',
}
